module.exports = __webpack_public_path__ + "static/media/home.1a4fd139.svg";